<script lang="ts">
  import app from '#app/app'
  import Link from '#app/lib/components/link.svelte'
  import { icon as iconFn } from '#app/lib/icons'
  import { treq } from '#app/lib/treq'
  import { getWikidataHistoryUrl, getWikidataUrl, type SerializedEntity } from '#entities/lib/entities'
  import { startRefreshTimeSpan } from '#entities/lib/entity_refresh'
  import Spinner from '#general/components/spinner.svelte'
  import { i18n, I18n } from '#user/lib/i18n'
  import { mainUserHasDataadminAccess } from '#user/lib/serialized_main_user'

  const {
    entity,
    showEntityEditButtons = true,
  }: {
    entity: SerializedEntity
    showEntityEditButtons?: boolean
  } = $props()

  const { uri, wdUri, invUri, type, claims } = $derived(entity)

  const wikidataUrl = $derived(wdUri ? getWikidataUrl(wdUri) : undefined)
  const wikidataHistoryUrl = $derived(wdUri ? getWikidataHistoryUrl(wdUri) : undefined)

  async function refreshEntity () {
    startRefreshTimeSpan(entity.uri)
    // Set refresh parameter to force router to navigate, despite the pathname being the same
    app.navigateAndLoad(`${entity.pathname}?refresh=true`)
  }

  let refreshing = $state(false)
  async function refreshExternalDatabasesData () {
    try {
      refreshing = true
      await treq('entities', 'post', 'enrich', { uris: [ uri ] })
      refreshEntity()
    } finally {
      refreshing = false
    }
  }
</script>

{#if showEntityEditButtons}
  <li>
    <Link
      url={`/entity/${uri}/edit`}
      text={i18n('Edit bibliographical info')}
      icon="pencil"
    />
  </li>
{/if}

{#if wikidataUrl}
  <li>
    <Link
      url={wikidataUrl}
      text={I18n('see_on_website', { website: 'wikidata.org' })}
      icon="wikidata"
    />
  </li>
{/if}

{#if claims['wdt:P212']}
  <li>
    <button
      onclick={refreshExternalDatabasesData}
      title={I18n('refresh external databases data')}
      disabled={refreshing}
    >
      {#if refreshing}
        <Spinner />
      {:else}
        {@html iconFn('refresh')}
      {/if}
      <span class="button-text">{I18n('refresh external databases data')}</span>
    </button>
  </li>
{:else if wikidataUrl}
  <li>
    <button
      onclick={refreshEntity}
      title={I18n('refresh Wikidata data')}
      disabled={refreshing}
    >
      {#if refreshing}
        <Spinner />
      {:else}
        {@html iconFn('refresh')}
      {/if}
      <span class="button-text">{I18n('refresh Wikidata data')}</span>
    </button>
  </li>
{/if}

{#if invUri}
  <li>
    <Link
      url={`/entity/${uri}/history`}
      text={I18n('entity history')}
      icon="history"
    />
  </li>
{:else if wikidataHistoryUrl}
  <li>
    <Link
      url={wikidataHistoryUrl}
      text={I18n('entity history')}
      icon="history"
    />
  </li>
{/if}

{#if mainUserHasDataadminAccess() && showEntityEditButtons}
  {#if type === 'human'}
    <li>
      <Link
        url={`/entity/${uri}/deduplicate`}
        text={i18n('Deduplicate sub-entities')}
        icon="compress"
      />
    </li>
  {/if}
  {#if type === 'serie'}
    <li>
      <Link
        url={`/entity/${uri}/cleanup`}
        text={I18n('cleanup entity')}
        icon="arrows"
      />
    </li>
  {/if}
{/if}
